import { render, staticRenderFns } from "./acceso-cuenta.vue?vue&type=template&id=50532975&"
import script from "./acceso-cuenta.vue?vue&type=script&lang=js&"
export * from "./acceso-cuenta.vue?vue&type=script&lang=js&"
import style0 from "./acceso-cuenta.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports